export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";